import { Outlet } from "react-router"

export const PublicLayout = ({ children }: { children?: React.ReactNode }) => {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children || <Outlet />}</>
}
export default PublicLayout
